export default class {
  // Set inital vars
  constructor(el) {
    this.el = el;
    this.link = this.el.querySelectorAll('a')[0];
    this.href = this.link.getAttribute('href');
  }

  // Initilize Module
  init() {
    if (this.href.includes('#')) {
      const scope = this;
      this.link.addEventListener('click', function(e) {
        e.preventDefault();

        // filter out the _ga string that gets appended to all urls
        const regex = /#([^&]+)/;
        const elementID = scope.href.match(regex);

        if(elementID) {
          const targetElement = document.querySelector(elementID);
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });
    }
  }

}
